import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

const domain = ENDPOINT_DOMAIN

export const login = (username, password) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/login`
        let body = {
            "username": username,
            "password": password
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const newLogin = (username, password, role) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/new-login`
        let body = {
            "role": role,
            "pid": username,
            "password": password
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const switchRole = (role) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/switch-role`
        let body = {
            "role": role,
        }

        let header = {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem("pg_access_token"),
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const checkRole = (role) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/check-role`

        let header = {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem("pg_access_token"),
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const loginOnesDiD = (accessToken) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/loginOnesDiD`
        let body = {
            "access_token": accessToken
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const loginMohPromt = (code, roleName) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/loginMohPromt`
        let body = {
            "code": code,
            "role": roleName
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const loginProviderID = (code, role) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/loginProviderID`
        let body = {
            "code": code,
            "role": role,
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const loginHealthID = (code) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/loginHealthID`
        let body = {
            "code": code,
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const RevocationAccount = (body) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/public/revocation/revocationAccount`
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const data = () => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/data`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const changPass = (password, confirm_password) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/changePassword`
        let body = {
            // "old_password": old_password,
            "password": password,
            "confirm_password": confirm_password
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}
export function updateProfileImage(formdata) {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/auth/updateProfileImage`
        // let body = {

        // }
        let header = {
            'Content-Type': 'multipart/form-data',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, formdata, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            // console.log(error)
        })
    })
}

export function updateProfileData(phone_number, email, current_address, permission, hospitalId) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/auth/updateProfileData`;
    let body = {
      phone_number: phone_number,
      email: email,
      current_address: {
        address: current_address.address,
        building: current_address.building,
        village_number: current_address.village_number,
        alley: current_address.alley,
        road: current_address.road,
        sub_district_id: current_address.sub_district_id,
        district_id: current_address.district_id,
        province_id: current_address.province_id,
        post_code: current_address.post_code,
      },
      hospitalId,
      permission: {
        policy_personal_information: permission.policy_personal_information,
        consent_form: permission.consent_form,
        access_to_email: permission.access_to_email
      },
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateProfilePatientData(phone_number, email, current_address, permission) {
    return new Promise((resolve) => {
      let url = `${domain}/api/v1/auth/updateProfileData`;
      let body = {
        phone_number: phone_number,
        email: email,
        current_address: {
          address: current_address.address,
          village_number: current_address.village_number,
          building: current_address.building,
          alley: current_address.alley,
          road: current_address.road,
          sub_district_id: current_address.sub_district_id,
          district_id: current_address.district_id,
          province_id: current_address.province_id,
          post_code: current_address.post_code,
        },
        permission: {
          policy_personal_information: permission.policy_personal_information,
          consent_form: permission.consent_form,
          access_to_email: permission.access_to_email
        },
      };
      let header = {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("pg_access_token"),
      };
      axios
        .post(url, body, { headers: header })
        .then((res) => {
          resolve(res);
        })
        .catch(() => {
          resolve(false);
        });
    });
}

export function addKratu(board_title, board_detail, show_name) {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/board/manage/newBoard`
        let body = {
            "board_title": board_title,
            "board_detail": board_detail,
            "show_name": show_name,
            "attachment_list": []
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export function getKratu() {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/board/manage/getBoard`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}